const translations = {
  en: {
    // Nav
    "nav.home": "Home",
    "nav.settings": "Settings",
    "nav.audit": "Audit Log",
    "nav.sharepoint": "SharePoint",
    "nav.planning": "Planning",
    "nav.signOut": "Sign out",
    "nav.profile": "Profile Settings",

    // Password Component
    "pwd.newPassword": "New Password",
    "pwd.confirmPassword": "Confirm Password",
    "pwd.placeholder": "Enter password",
    "pwd.confirmPlaceholder": "Re-enter password",
    "pwd.mismatch": "Passwords do not match",
    "pwd.match": "Passwords match",
    "pwd.veryWeak": "Very weak",
    "pwd.weak": "Weak",
    "pwd.fair": "Fair",
    "pwd.strong": "Strong",
    "pwd.veryStrong": "Very strong",
    "pwd.rule.minLength": "At least 8 characters",
    "pwd.rule.uppercase": "At least one uppercase letter",
    "pwd.rule.lowercase": "At least one lowercase letter",
    "pwd.rule.number": "At least one number",
    "pwd.rule.special": "At least one special character",

    // Profile / User Settings
    "profile.title": "Profile Settings",
    "profile.subtitle": "Manage your account and password",
    "profile.changePassword": "Change Password",
    "profile.changePasswordDesc": "Update your account password",
    "profile.currentPassword": "Current Password",
    "profile.currentPasswordPlaceholder": "Enter current password",
    "profile.savePassword": "Update Password",
    "profile.saving": "Updating...",
    "profile.passwordChanged": "Password updated successfully",
    "profile.passwordChangeFailed": "Failed to update password",

    // Login
    "login.title": "Sign in",
    "login.subtitle": "Enter your credentials to access the platform",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.contactAdmin": "Contact your administrator for access",
    "login.brandSubtitle": "Internal tools and project management",
    "login.forgotPassword": "Forgot your password?",

    // Forgot Password
    "forgot.title": "Reset Password",
    "forgot.subtitle": "Enter your email and we'll send you a link to reset your password.",
    "forgot.submit": "Send Reset Link",
    "forgot.hint": "You'll receive an email with a link to create a new password",
    "forgot.backToLogin": "Back to sign in",
    "forgot.sentTitle": "Check your email",
    "forgot.sentMessage": "If an account exists for {email}, we've sent a password reset link.",

    // Reset Password
    "reset.title": "Set New Password",
    "reset.subtitle": "Choose a strong new password for your account.",
    "reset.submit": "Reset Password",
    "reset.hint": "Your password must meet all complexity requirements",
    "reset.successTitle": "Password Reset",
    "reset.successMessage": "Your password has been reset successfully. You can now sign in with your new password.",
    "reset.goToLogin": "Sign in",
    "reset.invalidTitle": "Invalid Reset Link",
    "reset.invalidMessage": "This password reset link is invalid or missing. Please request a new one.",
    "reset.requestNew": "Request a new reset link",

    // Home
    "home.welcome": "Welcome back,",
    "home.projects": "Projects",
    "home.settings": "Settings",

    // Month names
    "month_1": "January",
    "month_2": "February",
    "month_3": "March",
    "month_4": "April",
    "month_5": "May",
    "month_6": "June",
    "month_7": "July",
    "month_8": "August",
    "month_9": "September",
    "month_10": "October",
    "month_11": "November",
    "month_12": "December",

    // Day abbreviations (0=Monday, 6=Sunday)
    "day_0": "Mon",
    "day_1": "Tue",
    "day_2": "Wed",
    "day_3": "Thu",
    "day_4": "Fri",
    "day_5": "Sat",
    "day_6": "Sun",
    "home.decayCalculator": "Decay Calculator",
    "home.planning": "Planning",
    "home.sharepoint": "SharePoint",
    "home.accounting": "Accounting",

    // Accounting
    "accounting.title": "Accounting",
    "accounting.subtitle": "Financial management",
    "accounting.backToHome": "Back to Home",
    "accounting.expenseReports": "Expense Reports",
    "accounting.employee": "Employee",
    "accounting.amount": "Amount",
    "accounting.total": "Total",
    "accounting.noData": "No data available for this month",
    "accounting.fetchError": "Failed to load expense reports",

    // Planning
    "planning.title": "Planning",
    "planning.backToHome": "Back to Home",
    "planning.subtitle": "Yearly planning spreadsheets",
    "planning.currentYear": "Current Year",
    "planning.previousYears": "Previous Years",
    "planning.openInExcel": "Open in Excel",
    "planning.noFiles": "No planning files found",
    "planning.noFilesDesc": "Upload Planning_YYYY.xlsx files to the Planning folder in SharePoint.",
    "planning.openingExcel": "Opening in Excel...",
    "planning.fallbackPreview": "Excel not detected, opening web preview...",
    "planning.goToFolder": "Open Planning Folder",
    "planning.lastModified": "Last modified",

    // Planning Calendar
    "planningCal.date": "Date",
    "planningCal.futureTasks": "Future Tasks",
    "planningCal.loadError": "Failed to load calendar data",

    // Decay Calculator
    "decay.title": "Decay Calculator",
    "decay.backToHome": "Back to Home",
    "decay.element": "Element",
    "decay.isotope": "Isotope",
    "decay.selectElement": "Select an element",
    "decay.selectIsotope": "Select an isotope",
    "decay.selectElementFirst": "Select an element first",
    "decay.initialActivity": "Initial Activity",
    "decay.inputUnit": "Input Unit",
    "decay.outputUnit": "Output Unit",
    "decay.originDate": "Origin Date",
    "decay.originTime": "Origin Time",
    "decay.targetDate": "Target Date",
    "decay.targetTime": "Target Time",
    "decay.calculate": "Calculate",
    "decay.result": "Result",
    "decay.halfLife": "Half-life",
    "decay.originDateTime": "Origin Date/Time",
    "decay.targetDateTime": "Target Date/Time",
    "decay.elapsedTime": "Elapsed Time",
    "decay.decayFactor": "Decay Factor",
    "decay.finalActivity": "Final Activity",
    "decay.noElements": "No elements available. An administrator needs to add elements and isotopes first.",
    "decay.errorTargetBeforeOrigin": "Target must be after origin",
    "decay.print": "Print / Save as PDF",
    "decay.tabDateTime": "Date & Time",
    "decay.tabQuick": "Quick",
    "decay.quickTimeLabel": "Time",
    "decay.quickBefore": "Before",
    "decay.quickAfter": "After",
    "decay.quickTimeDelta": "Time Delta",
    "decay.timeUnit_seconds": "Seconds",
    "decay.timeUnit_minutes": "Minutes",
    "decay.timeUnit_hours": "Hours",
    "decay.timeUnit_days": "Days",
    "decay.timeUnit_years": "Years",

    // Projects page
    "projects.title": "Projects",
    "projects.newProject": "New Project",
    "projects.search": "Search projects...",
    "projects.allStatus": "All Status",
    "projects.allCategories": "All Categories",
    "projects.noProjects": "No projects found",
    "projects.noActive": "No active projects",
    "projects.closedSection": "Closed Projects",
    "projects.backToHome": "Back to Home",

    // Create project dialog
    "projects.create.title": "Create Project",
    "projects.create.name": "Title",
    "projects.create.namePlaceholder": "Project name",
    "projects.create.description": "Description",
    "projects.create.descriptionPlaceholder": "Brief description of the project",
    "projects.create.status": "Status",
    "projects.create.category": "Category",
    "projects.create.categoryPlaceholder": "Select a category",
    "projects.create.cancel": "Cancel",
    "projects.create.submit": "Create",

    // Statuses
    "status.notStarted": "Not Started",
    "status.open": "Open",
    "status.closed": "Closed",

    // Project detail
    "project.backToProjects": "Back to projects",
    "project.updates": "Updates",
    "project.files": "Files",
    "project.meetings": "Meetings",
    "project.noDescription": "No description",
    "project.updatePlaceholder": "Share an update on this project...",
    "project.attach": "Attach",
    "project.post": "Post",
    "project.noUpdates": "No updates yet. Be the first to add one!",
    "project.dropUpload": "Drop or click to upload",
    "project.noFiles": "No files uploaded yet",
    "project.addMeeting": "Add",
    "project.allMeetings": "All Meetings",
    "project.noMeetingsDate": "No meetings on",
    "project.noMeetings": "No meetings scheduled",
    "project.past": "Past",
    "project.deleteProject": "Delete Project",
    "project.deleteProjectDesc": "This will permanently delete this project and all its updates and files.",
    "project.deleteUpdate": "Delete Update",
    "project.deleteUpdateDesc": "Are you sure you want to delete this update? This action cannot be undone.",
    "project.meeting": "Meeting",
    "project.selectCategory": "Select category",

    // Meeting dialog
    "meeting.schedule": "Schedule Meeting",
    "meeting.title": "Title",
    "meeting.titlePlaceholder": "Meeting title",
    "meeting.date": "Date",
    "meeting.startTime": "Start Time",
    "meeting.endTime": "End Time",
    "meeting.cancel": "Cancel",
    "meeting.create": "Create",

    // File preview
    "file.view": "View",
    "file.download": "Download",
    "file.close": "Close",

    // Settings
    "settings.title": "Settings",
    "settings.subtitle": "Manage your workspace configuration",
    "settings.users": "Users",
    "settings.categories": "Categories",
    "settings.addUser": "Add User",
    "settings.addCategory": "Add Category",
    "settings.backToHome": "Back to Home",
    "settings.projects": "Projects",
    "settings.projectsDesc": "Categories and project configuration",
    "settings.decayCalculator": "Decay Calculator",
    "settings.decayDesc": "Elements and isotope database",
    "settings.usersDesc": "Team members and access control",
    "settings.emailDesc": "SMTP and two-factor authentication",

    // Users table
    "users.user": "User",
    "users.role": "Role",
    "users.joined": "Joined",
    "users.actions": "Actions",
    "users.admin": "Admin",
    "users.managerRole": "Manager",
    "users.userRole": "User",

    // Edit user
    "users.edit.title": "Edit User",
    "users.edit.displayName": "Display Name",
    "users.edit.color": "Color",
    "users.edit.role": "Role",
    "users.edit.newPassword": "New Password (optional)",
    "users.edit.newPasswordPlaceholder": "Leave empty to keep current",
    "users.edit.cancel": "Cancel",
    "users.edit.save": "Save",

    // Create user
    "users.create.title": "Create New User",
    "users.create.email": "Email",
    "users.create.emailPlaceholder": "user@company.com",
    "users.create.password": "Password",
    "users.create.passwordPlaceholder": "Password",
    "users.create.displayName": "Display Name",
    "users.create.displayNamePlaceholder": "John Doe",
    "users.create.role": "Role",
    "users.create.submit": "Create User",
    "users.create.cancel": "Cancel",

    // Delete user
    "users.delete.title": "Delete User",
    "users.delete.desc": "Are you sure you want to delete {name}? This action cannot be undone.",
    "users.delete.cancel": "Cancel",
    "users.delete.confirm": "Delete",

    // Categories
    "categories.edit": "Edit Category",
    "categories.new": "New Category",
    "categories.name": "Category Name",
    "categories.namePlaceholder": "e.g. Marketing, Development",
    "categories.color": "Category Color",
    "categories.save": "Save",
    "categories.cancel": "Cancel",
    "categories.noCategories": "No categories yet",
    "categories.delete.title": "Delete Category",
    "categories.delete.desc": 'Are you sure you want to delete "{name}"? Projects using this category will need to be updated.',

    // Common
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.save": "Save",
    "common.close": "Close",
    "common.confirmDelete": "Confirm Delete",
    "common.create": "Create",
    "common.by": "by",

    // Lockout
    "login.accountLocked": "Your account has been locked due to too many failed login attempts. Please reset your password via email or contact an administrator to unlock it.",
    "users.locked": "Locked",
    "users.unlock": "Unlock",
    "users.unlockSuccess": "Account unlocked successfully",
    "users.unlockError": "Failed to unlock account",
    "users.unlockConfirmTitle": "Unlock Account",
    "users.unlockConfirmDesc": "This will unlock {name}'s account and allow them to sign in again.",

    // Toasts
    "toast.statusUpdated": "Status updated",
    "toast.categoryUpdated": "Category updated",
    "toast.updateAdded": "Update added",
    "toast.updateDeleted": "Update deleted",
    "toast.fileUploaded": "File uploaded",
    "toast.fileDeleted": "File deleted",
    "toast.meetingCreated": "Meeting created",
    "toast.meetingDeleted": "Meeting deleted",
    "toast.projectDeleted": "Project deleted",
    "toast.projectCreated": "Project created",
    "toast.titleUpdated": "Title updated",
    "toast.descriptionUpdated": "Description updated",
    "toast.userUpdated": "User updated",
    "toast.userCreated": "User created",
    "toast.userDeleted": "User deleted",
    "toast.categoryCreated": "Category created",
    "toast.categorySaved": "Category updated",
    "toast.categoryDeleted": "Category deleted",
    "toast.languageUpdated": "Language updated",
    "toast.failedLoad": "Failed to load data",
    "toast.failedLoadProject": "Failed to load project",
    "toast.noChanges": "No changes to save",

    // 2FA
    "login.2fa.title": "Two-Factor Authentication",
    "login.2fa.subtitle": "We sent a 6-digit code to {email}",
    "login.2fa.verify": "Verify",
    "login.2fa.resend": "Resend code",
    "login.2fa.sending": "Sending...",
    "login.2fa.codeSent": "A new code has been sent to your email.",
    "login.2fa.back": "Back to login",
    "login.2fa.expires": "Code expires in 10 minutes",

    // SMTP / Email Settings
    "settings.email": "Email",
    "smtp.title": "Email Configuration",
    "smtp.description": "Configure SMTP settings to enable two-factor authentication and email notifications.",
    "smtp.host": "SMTP Host",
    "smtp.hostPlaceholder": "smtp.gmail.com",
    "smtp.port": "Port",
    "smtp.username": "Username",
    "smtp.usernamePlaceholder": "your-email@gmail.com",
    "smtp.password": "Password",
    "smtp.passwordPlaceholder": "App password or SMTP password",
    "smtp.senderEmail": "Sender Email",
    "smtp.senderPlaceholder": "noreply@yourcompany.com",
    "smtp.save": "Save Settings",
    "smtp.saving": "Saving...",
    "smtp.saved": "SMTP settings saved",
    "smtp.saveFailed": "Failed to save SMTP settings",
    "smtp.testTitle": "Send Test Email",
    "smtp.testEmail": "Recipient Email",
    "smtp.testEmailPlaceholder": "test@example.com",
    "smtp.sendTest": "Send Test",
    "smtp.sending": "Sending...",
    "smtp.testSuccess": "Test email sent successfully",
    "smtp.testFailed": "Failed to send test email",
    "smtp.notConfigured": "SMTP is not configured yet. Save your settings first.",
    "smtp.configured": "Configured",
    "smtp.notConfiguredBadge": "Not configured",
    "smtp.2faNote": "When SMTP is configured, two-factor authentication is automatically enabled for all users on new devices.",
    "smtp.2faToggleTitle": "Two-Factor Authentication (2FA)",
    "smtp.2faToggleDesc": "When enabled, users must verify their identity via email on new devices.",
    "smtp.2faStatusOn": "2FA is active — email verification required on new devices",
    "smtp.2faStatusOff": "2FA is disabled — users log in with password only",
    "smtp.2faEnabled": "Two-factor authentication enabled",
    "smtp.2faDisabled": "Two-factor authentication disabled",

    // Security / Key Rotation
    "settings.security": "Security",
    "settings.securityDesc": "Encryption and data protection",
    "security.dbEncryption": "Database Encryption",
    "security.dbEncryptionDesc": "All sensitive data is encrypted at rest using AES-256-GCM.",
    "security.fileEncryption": "File Storage Encryption",
    "security.fileEncryptionDesc": "Encryption for uploaded files and attachments.",
    "security.comingSoon": "Coming soon",
    "security.keyWarning": "If the encryption key is lost, all database data becomes permanently unrecoverable. Store the key in a secure location.",
    "security.rotateKey": "Rotate Encryption Key",
    "security.rotateDesc": "Replace the current encryption key. All data will be re-encrypted with the new key.",
    "security.currentKey": "Current Key",
    "security.currentKeyPlaceholder": "Enter your current encryption key",
    "security.newKey": "New Key",
    "security.newKeyPlaceholder": "Enter the new encryption key (min 8 characters)",
    "security.rotate": "Rotate Key",
    "security.rotating": "Rotating...",
    "security.rotateSuccess": "Encryption key rotated successfully",

    // Key Rotation Banner
    "keyRotation.actionRequired": "Action Required on Railway",
    "keyRotation.dbKeyPending": "A database encryption key rotation was performed, but the ENCRYPTION_KEY environment variable on Railway has not yet been updated.",
    "keyRotation.fileKeyPending": "A file encryption key rotation was performed, but the R2_ENCRYPTION_KEY environment variable on Railway has not yet been updated.",
    "keyRotation.step1": "Update {KEY} in Railway Variables with the new value",
    "keyRotation.step2": "Redeploy the service",
    "keyRotation.autoResolve": "This banner will disappear automatically once the redeploy completes.",
    "keyRotation.modalTitle": "Action Required on Railway",
    "keyRotation.modalBody": "The key rotation completed successfully. You must now update the environment variable on Railway and redeploy for the change to persist across restarts.",
    "keyRotation.modalConfirm": "Got it",
    "security.rotateFailed": "Key rotation failed",
    "security.active": "Active",

    // SharePoint
    "sharepoint.title": "SharePoint",
    "sharepoint.subtitle": "File storage and sharing",
    "sharepoint.file": "file",
    "sharepoint.files": "files",
    "sharepoint.root": "SharePoint",
    "sharepoint.upload": "Upload",
    "sharepoint.uploading": "Uploading...",
    "sharepoint.newFolder": "New Folder",
    "sharepoint.folderName": "Folder name",
    "sharepoint.folderNamePlaceholder": "Enter folder name",
    "sharepoint.create": "Create",
    "sharepoint.emptyFolder": "This folder is empty",
    "sharepoint.emptyFolderDesc": "Upload files or create a new folder to get started.",
    "sharepoint.newFolderDesc": "Enter a name for the new folder.",
    "sharepoint.previewUnavailable": "Preview Unavailable",
    "sharepoint.renameDesc": "Enter a new name for this item.",
    "sharepoint.name": "Name",
    "sharepoint.type": "Type",
    "sharepoint.size": "Size",
    "sharepoint.date": "Date",
    "sharepoint.actions": "Actions",
    "sharepoint.folder": "Folder",
    "sharepoint.properties": "Properties",
    "sharepoint.uploadedBy": "Uploaded by",
    "sharepoint.download": "Download",
    "sharepoint.loadError": "Failed to load files",
    "sharepoint.folderCreated": "Folder created",
    "sharepoint.folderError": "Failed to create folder",
    "sharepoint.fileUploaded": "File uploaded",
    "sharepoint.filesUploaded": "{count} files uploaded",
    "sharepoint.uploadError": "Upload failed",
    "sharepoint.uploadTooLarge": "File exceeds the 5 GB upload limit.",
    "sharepoint.deleted": "Item deleted",
    "sharepoint.deleteError": "Failed to delete",
    "sharepoint.conflictTitle": "File Already Exists",
    "sharepoint.conflictDescSingle": "A file named \"{name}\" already exists in this folder.",
    "sharepoint.conflictDescMulti": "{count} files already exist in this folder.",
    "sharepoint.conflictReplace": "Replace",
    "sharepoint.conflictKeepBoth": "Keep Both",
    "sharepoint.deleteConfirmTitle": "Delete item",
    "sharepoint.deleteFolderDesc": "Delete folder \"{name}\" and all its contents? This cannot be undone.",
    "sharepoint.deleteFileDesc": "Delete file \"{name}\"? This cannot be undone.",
    "sharepoint.dropHere": "Drop files here to upload",
    "sharepoint.rename": "Rename",
    "sharepoint.renamed": "Item renamed",
    "sharepoint.renameError": "Failed to rename",
    "sharepoint.ctxOpen": "Open",
    "sharepoint.copy": "Copy",
    "sharepoint.paste": "Paste",
    "sharepoint.copied": "Copied \"{name}\" to clipboard",
    "sharepoint.pasted": "Pasted \"{name}\"",
    "sharepoint.pasteError": "Failed to paste file",
    "sharepoint.preview": "Preview",
    "sharepoint.previewError": "Failed to generate preview",
    "sharepoint.preparingPreview": "Preparing preview...",
    "sharepoint.previewNotAvailable": "Preview Not Available",
    "sharepoint.previewNotAvailableDesc": "Preview is not available for \"{name}\". You can download the file instead.",

    // Search
    "sharepoint.searchPlaceholder": "Search files and folders...",
    "sharepoint.searchNoResults": "No results found",
    "sharepoint.searchError": "Search failed",

    // Multi-select & Bulk operations
    "sharepoint.itemsSelected": "{count} items selected",
    "sharepoint.totalItems": "{count} items",
    "sharepoint.cut": "Cut",
    "sharepoint.pasteHere": "Paste here",
    "sharepoint.deleteSelected": "Delete {count} items",
    "sharepoint.downloadZip": "Download as ZIP",
    "sharepoint.bulkDeleteTitle": "Delete {count} items?",
    "sharepoint.bulkDeleteDesc": "The following items will be permanently deleted:",
    "sharepoint.bulkDeleted": "{count} items deleted",
    "sharepoint.bulkMoved": "{count} items moved",
    "sharepoint.bulkCopied": "{count} items copied",
    "sharepoint.cutActive": "{count} items cut to clipboard",
    "sharepoint.copiedMulti": "{count} items copied to clipboard",
    "sharepoint.moveError": "Failed to move items",
    "sharepoint.copyError": "Failed to copy items",
    "sharepoint.listView": "List view",
    "sharepoint.gridView": "Grid view",

    // Office URI Scheme
    "sharepoint.openingInExcel": "Opening in Excel...",
    "sharepoint.openingInWord": "Opening in Word...",
    "sharepoint.openingInPowerPoint": "Opening in PowerPoint...",
    "sharepoint.officeFallback": "Office desktop not detected. Opening in browser preview...",
    "sharepoint.lastModified": "Last Modified",
    "sharepoint.fullPath": "Full Path",
    "sharepoint.formatExcel": "Microsoft Excel Spreadsheet",
    "sharepoint.formatWord": "Microsoft Word Document",
    "sharepoint.formatPowerPoint": "Microsoft PowerPoint Presentation",
    "sharepoint.formatPdf": "PDF Document",
    "sharepoint.formatImage": "Image",
    "sharepoint.formatVideo": "Video",
    "sharepoint.formatAudio": "Audio",
    "sharepoint.formatArchive": "Archive",
    "sharepoint.formatText": "Text Document",
    "sharepoint.formatFile": "File",
    "sharepoint.selectAll": "Select all",
    "sharepoint.officeSaved": "File saved from desktop application",

    // Pinned folders
    "sharepoint.pinToSidebar": "Pin to sidebar",
    "sharepoint.unpinFromSidebar": "Unpin from sidebar",
    "sharepoint.pinnedFolders": "Pinned",
    "sharepoint.filesLabel": "files",
    "sharepoint.backToHome": "Back to Home",

    // Archive Viewer
    "archive.sessionExpired": "Archive session expired or not found",
    "archive.loadError": "Failed to load archive contents",
    "archive.previewError": "Failed to preview file",
    "archive.downloadError": "Failed to download file",
    "archive.noSession": "No archive session found",
    "archive.tempSession": "Temporary session",
    "archive.back": "Back",
    "archive.empty": "This folder is empty",
    "archive.colName": "Name",
    "archive.colSize": "Size",
    "archive.colType": "Type",
    "archive.colActions": "Actions",
    "archive.folder": "Folder",
    "archive.preview": "Preview",
    "archive.downloadFile": "Download",

    // Settings — SharePoint
    "settings.sharepoint": "SharePoint",
    "settings.sharepointDesc": "R2 storage configuration",
    "r2.title": "Cloudflare R2 Configuration",
    "r2.description": "Configure the S3-compatible storage for SharePoint file management.",
    "r2.accessKeyId": "Access Key ID",
    "r2.secretAccessKey": "Secret Access Key",
    "r2.endpointUrl": "Endpoint URL",
    "r2.endpointPlaceholder": "https://your-account-id.r2.cloudflarestorage.com",
    "r2.bucketName": "Bucket Name",
    "r2.save": "Save Configuration",
    "r2.saving": "Saving...",
    "r2.saved": "R2 configuration saved",
    "r2.saveFailed": "Failed to save R2 configuration",
    "r2.configured": "Configured",
    "r2.notConfigured": "Not configured",
    "r2.testConnection": "Test Connection",
    "r2.testing": "Testing...",
    "r2.testSuccess": "Connection successful",
    "r2.testFailed": "Connection failed",

    // Backup R2 Configuration
    "backupR2.title": "Backup Configuration",
    "backupR2.description": "Configure a dedicated R2 bucket for encrypted backups.",
    "backupR2.accessKeyId": "Backup Access Key ID",
    "backupR2.secretAccessKey": "Backup Secret Access Key",
    "backupR2.endpointUrl": "Backup Endpoint URL",
    "backupR2.bucketName": "Backup Bucket Name",
    "backupR2.saved": "Backup R2 configuration saved",
    "backupR2.saveFailed": "Failed to save backup R2 configuration",

    // Backup
    "backup.title": "Backup",
    "backup.subtitle": "Choose how to back up all SharePoint files.",
    "backup.description": "Choose how to back up all SharePoint files.",
    "backup.localTitle": "Download locally",
    "backup.localBackup": "Download locally",
    "backup.localDesc": "Download all files as a decrypted .zip archive to your computer.",
    "backup.r2Title": "Backup to Cloudflare R2",
    "backup.r2Backup": "Backup to Cloudflare R2",
    "backup.r2Desc": "Send all files (encrypted) to the dedicated backup R2 bucket.",
    "backup.warning": "Please confirm",
    "backup.confirmLocal": "This backup contains decrypted sensitive files. Store the downloaded archive securely.",
    "backup.confirmR2": "This will upload a timestamped .zip of all encrypted files to the backup R2 bucket.",
    "backup.localWarning": "This backup contains decrypted sensitive files. Store the downloaded archive securely.",
    "backup.r2Warning": "This will upload a timestamped .zip of all encrypted files to the backup R2 bucket.",
    "backup.confirm": "Start Backup",
    "backup.startBackup": "Start Backup",
    "backup.inProgress": "Backing up...",
    "backup.localSuccess": "Backup downloaded successfully",
    "backup.localError": "Failed to download backup",
    "backup.r2Success": "Backup uploaded to R2 successfully",
    "backup.r2Error": "Failed to upload backup to R2",

    // Settings — File Encryption
    "security.fileKeyTitle": "File Encryption Key",
    "security.fileKeyDesc": "Set the AES-256 encryption key used for all files stored in SharePoint.",
    "security.fileKeyWarning": "If the file encryption key is lost, all files in SharePoint become permanently unrecoverable.",
    "security.fileKeyPlaceholder": "Enter the file encryption key (min 8 characters)",
    "security.fileKeySave": "Save Key",
    "security.fileKeySaving": "Saving...",
    "security.fileKeySaved": "File encryption key saved",
    "security.fileKeySaveFailed": "Failed to save file encryption key",
    "security.fileKeyEnvOnly": "The file encryption key is managed as a Railway environment variable (R2_ENCRYPTION_KEY). Set it directly in Railway and restart the service to activate encryption.",
    "security.fileKeyRotateDesc": "Replace the current file encryption key. All files will be re-encrypted with the new key.",
    "security.rotateFileKey": "Rotate File Encryption Key",
    "security.currentFileKey": "Current File Key",
    "security.newFileKey": "New File Key",
    "security.rotateFileSuccess": "File encryption key rotated successfully",
    "security.rotateFileFailed": "File key rotation failed",

    // Language
    "lang.english": "English",
    "lang.italian": "Italiano",

    // Audit Log
    "settings.auditLog": "Audit Log",
    "settings.auditDesc": "Activity and security event history",
    "audit.title": "Audit Log",
    "audit.backToHome": "Back to Home",
    "audit.subtitle": "All system events and user actions",
    "audit.fetchError": "Failed to load audit logs",
    "audit.search": "Search",
    "audit.searchPlaceholder": "Search actions, users...",
    "audit.user": "User",
    "audit.allUsers": "All users",
    "audit.actionType": "Type",
    "audit.allTypes": "All types",
    "audit.from": "From",
    "audit.to": "To",
    "audit.clearFilters": "Clear",
    "audit.noEntries": "No audit log entries found",
    "audit.showing": "Showing",
    "audit.of": "of",
    "audit.exportPDF": "Export PDF",
    "audit.exportSuccess": "Audit log exported successfully",
    "audit.exportError": "Failed to export audit log",
    "audit.appliedFilters": "Filters applied",
    "audit.totalEntries": "Total entries",
    "audit.exported": "Exported on",
    "audit.col.datetime": "Date / Time",
    "audit.col.user": "User",
    "audit.col.action": "Action",
    "audit.col.type": "Type",
    "audit.col.ip": "IP Address",
    "audit.type.auth": "Auth",
    "audit.type.user": "User",
    "audit.type.password": "Password",
    "audit.type.settings": "Settings",
    "audit.type.security": "Security",
    "audit.type.sharepoint": "SharePoint",
    "audit.type.backup": "Backup",
    "audit.type.other": "Other",

    // Settings - Isotopes
    "settings.isotopes": "Isotopes",
    "isotopes.addElement": "Add Element",
    "isotopes.addIsotope": "Add Isotope",
    "isotopes.elementName": "Element Name",
    "isotopes.elementPlaceholder": "e.g. Gallium, Fluorine",
    "isotopes.isotopeName": "Isotope Name",
    "isotopes.isotopePlaceholder": "e.g. Ga-68, F-18",
    "isotopes.halfLifeValue": "Half-life Value",
    "isotopes.halfLifeUnit": "Half-life Unit",
    "isotopes.noElements": "No elements yet. Add an element to get started.",
    "isotopes.noIsotopes": "No isotopes. Click + to add one.",
    "isotopes.deleteElement": "Delete Element",
    "isotopes.deleteElementDesc": 'Delete "{name}" and all its isotopes?',
    "isotopes.editElement": "Edit Element",
    "isotopes.editIsotope": "Edit Isotope",
    "isotopes.newIsotope": "New Isotope",
    "isotopes.newElement": "New Element",
    "isotopes.seconds": "seconds",
    "isotopes.minutes": "minutes",
    "isotopes.hours": "hours",
    "isotopes.days": "days",
    "isotopes.years": "years",

    // Trasferte
    "nav.trasferte": "Trips",
    "home.trasferte": "Trips",
    "trasferte.title": "Trips",
    "trasferte.subtitle": "Business trips knowledge base",
    "trasferte.searchPlaceholder": "Search a country…",
    "trasferte.selectInstruction": "Select a country on the map",
    "trasferte.cityPlaceholder": "City not specified",
    "trasferte.selectPrompt": "Click a country on the map or search above to see details.",
    "trasferte.tabInfo": "Country Info",
    "trasferte.tabTrips": "Past Trips",
    "trasferte.pastTripsIn": "Past trips in",
    "trasferte.noTrips": "No trips recorded for this country yet.",
    "trasferte.loadError": "Failed to load trips",
    "trasferte.loading": "Loading…",
    "trasferte.localCurrency": "Local Currency",
    "trasferte.currencyUnknown": "Currency info not available",
    "trasferte.exchangeRate": "Live Exchange Rate",
    "trasferte.lastUpdated": "Last updated",
    "trasferte.rateError": "Rate currently unavailable",
    "trasferte.viaggiareSicuri": "Consult Viaggiare Sicuri (MAE)",
    "trasferte.addTrip": "Add Trip",
    "trasferte.addModalTitle": "Add Business Trip",
    "trasferte.city": "City",
    "trasferte.client": "Client",
    "trasferte.clientName": "Client name",
    "trasferte.clientContact": "Website / address",
    "trasferte.clientContactPlaceholder": "www.example.com",
    "trasferte.airport": "Airport used",
    "trasferte.airportPlaceholder": "e.g. MUC — Munich Airport",
    "trasferte.hotels": "Hotels",
    "trasferte.hotelPlaceholder": "Hotel name",
    "trasferte.addHotel": "Add hotel",
    "trasferte.transport.label": "Transport",
    "trasferte.transport.rental": "Rental car",
    "trasferte.transport.uber": "Uber / Taxi",
    "trasferte.transport.client": "Covered by client",
    "trasferte.transport.public": "Public transport",
    "trasferte.transport.other": "Other",
    "trasferte.transportNotePlaceholder": "Optional note (e.g. Hertz pickup at airport)",
    "trasferte.restaurants": "Recommended restaurants",
    "trasferte.restaurantName": "Restaurant name",
    "trasferte.restaurantNote": "Short note (optional)",
    "trasferte.addRestaurant": "Add restaurant",
    "trasferte.tips": "Tips & notes",
    "trasferte.tipsPlaceholder": "Anything worth remembering for the next time…",
    "trasferte.addedBy": "Added by",
    "trasferte.save": "Save Trip",
    "trasferte.created": "Trip saved",
    "trasferte.saveError": "Failed to save trip",
    "trasferte.formRequiredError": "City and Client name are required",
    "trasferte.legendWithTrip": "Has trips",
    "trasferte.legendNoTrip": "No trips",
    "trasferte.legendSelected": "Selected",
    "trasferte.delete": "Delete",
    "trasferte.deleting": "Deleting…",
    "trasferte.deleted": "Trip deleted",
    "trasferte.deleteError": "Failed to delete trip",
    "trasferte.deleteTrip": "Delete trip",
    "trasferte.deleteTripAria": "Delete this trip",
    "trasferte.deleteTripTitle": "Delete this trip?",
    "trasferte.deleteTripConfirm": "Are you sure you want to delete this trip? This action cannot be undone.",

    // Country names (used in tooltip, search results, country card title)
    "trasferte.country.AE": "United Arab Emirates",
    "trasferte.country.AR": "Argentina",
    "trasferte.country.AT": "Austria",
    "trasferte.country.AU": "Australia",
    "trasferte.country.BE": "Belgium",
    "trasferte.country.BG": "Bulgaria",
    "trasferte.country.BR": "Brazil",
    "trasferte.country.CA": "Canada",
    "trasferte.country.CH": "Switzerland",
    "trasferte.country.CL": "Chile",
    "trasferte.country.CN": "China",
    "trasferte.country.CO": "Colombia",
    "trasferte.country.CY": "Cyprus",
    "trasferte.country.CZ": "Czech Republic",
    "trasferte.country.DE": "Germany",
    "trasferte.country.DK": "Denmark",
    "trasferte.country.EE": "Estonia",
    "trasferte.country.EG": "Egypt",
    "trasferte.country.ES": "Spain",
    "trasferte.country.FI": "Finland",
    "trasferte.country.FR": "France",
    "trasferte.country.GB": "United Kingdom",
    "trasferte.country.GR": "Greece",
    "trasferte.country.HK": "Hong Kong",
    "trasferte.country.HR": "Croatia",
    "trasferte.country.HU": "Hungary",
    "trasferte.country.ID": "Indonesia",
    "trasferte.country.IE": "Ireland",
    "trasferte.country.IL": "Israel",
    "trasferte.country.IN": "India",
    "trasferte.country.IS": "Iceland",
    "trasferte.country.IT": "Italy",
    "trasferte.country.JP": "Japan",
    "trasferte.country.KR": "South Korea",
    "trasferte.country.LT": "Lithuania",
    "trasferte.country.LU": "Luxembourg",
    "trasferte.country.LV": "Latvia",
    "trasferte.country.MA": "Morocco",
    "trasferte.country.MT": "Malta",
    "trasferte.country.MX": "Mexico",
    "trasferte.country.MY": "Malaysia",
    "trasferte.country.NG": "Nigeria",
    "trasferte.country.NL": "Netherlands",
    "trasferte.country.NO": "Norway",
    "trasferte.country.NZ": "New Zealand",
    "trasferte.country.PE": "Peru",
    "trasferte.country.PH": "Philippines",
    "trasferte.country.PL": "Poland",
    "trasferte.country.PT": "Portugal",
    "trasferte.country.QA": "Qatar",
    "trasferte.country.RO": "Romania",
    "trasferte.country.RS": "Serbia",
    "trasferte.country.RU": "Russia",
    "trasferte.country.SA": "Saudi Arabia",
    "trasferte.country.SE": "Sweden",
    "trasferte.country.SG": "Singapore",
    "trasferte.country.SI": "Slovenia",
    "trasferte.country.SK": "Slovakia",
    "trasferte.country.TH": "Thailand",
    "trasferte.country.TN": "Tunisia",
    "trasferte.country.TR": "Turkey",
    "trasferte.country.TW": "Taiwan",
    "trasferte.country.UA": "Ukraine",
    "trasferte.country.US": "United States",
    "trasferte.country.VN": "Vietnam",
    "trasferte.country.ZA": "South Africa",

    // Currency display names
    "trasferte.currency.AED": "UAE Dirham",
    "trasferte.currency.ARS": "Argentine Peso",
    "trasferte.currency.AUD": "Australian Dollar",
    "trasferte.currency.BGN": "Bulgarian Lev",
    "trasferte.currency.BRL": "Brazilian Real",
    "trasferte.currency.CAD": "Canadian Dollar",
    "trasferte.currency.CHF": "Swiss Franc",
    "trasferte.currency.CLP": "Chilean Peso",
    "trasferte.currency.CNY": "Chinese Yuan",
    "trasferte.currency.COP": "Colombian Peso",
    "trasferte.currency.CZK": "Czech Koruna",
    "trasferte.currency.DKK": "Danish Krone",
    "trasferte.currency.EGP": "Egyptian Pound",
    "trasferte.currency.EUR": "Euro",
    "trasferte.currency.GBP": "Pound Sterling",
    "trasferte.currency.HKD": "Hong Kong Dollar",
    "trasferte.currency.HUF": "Hungarian Forint",
    "trasferte.currency.IDR": "Indonesian Rupiah",
    "trasferte.currency.ILS": "Israeli New Shekel",
    "trasferte.currency.INR": "Indian Rupee",
    "trasferte.currency.ISK": "Icelandic Króna",
    "trasferte.currency.JPY": "Japanese Yen",
    "trasferte.currency.KRW": "South Korean Won",
    "trasferte.currency.MAD": "Moroccan Dirham",
    "trasferte.currency.MXN": "Mexican Peso",
    "trasferte.currency.MYR": "Malaysian Ringgit",
    "trasferte.currency.NGN": "Nigerian Naira",
    "trasferte.currency.NOK": "Norwegian Krone",
    "trasferte.currency.NZD": "New Zealand Dollar",
    "trasferte.currency.PEN": "Peruvian Sol",
    "trasferte.currency.PHP": "Philippine Peso",
    "trasferte.currency.PLN": "Polish Złoty",
    "trasferte.currency.QAR": "Qatari Riyal",
    "trasferte.currency.RON": "Romanian Leu",
    "trasferte.currency.RSD": "Serbian Dinar",
    "trasferte.currency.RUB": "Russian Ruble",
    "trasferte.currency.SAR": "Saudi Riyal",
    "trasferte.currency.SEK": "Swedish Krona",
    "trasferte.currency.SGD": "Singapore Dollar",
    "trasferte.currency.THB": "Thai Baht",
    "trasferte.currency.TND": "Tunisian Dinar",
    "trasferte.currency.TRY": "Turkish Lira",
    "trasferte.currency.TWD": "New Taiwan Dollar",
    "trasferte.currency.UAH": "Ukrainian Hryvnia",
    "trasferte.currency.USD": "US Dollar",
    "trasferte.currency.VND": "Vietnamese Dong",
    "trasferte.currency.ZAR": "South African Rand",
  },

  it: {
    // Nav
    "nav.home": "Home",
    "nav.settings": "Impostazioni",
    "nav.audit": "Registro Attivit\u00e0",
    "nav.sharepoint": "SharePoint",
    "nav.planning": "Pianificazione",
    "nav.signOut": "Esci",
    "nav.profile": "Impostazioni Profilo",

    // Password Component
    "pwd.newPassword": "Nuova Password",
    "pwd.confirmPassword": "Conferma Password",
    "pwd.placeholder": "Inserisci password",
    "pwd.confirmPlaceholder": "Reinserisci password",
    "pwd.mismatch": "Le password non corrispondono",
    "pwd.match": "Le password corrispondono",
    "pwd.veryWeak": "Molto debole",
    "pwd.weak": "Debole",
    "pwd.fair": "Discreta",
    "pwd.strong": "Forte",
    "pwd.veryStrong": "Molto forte",
    "pwd.rule.minLength": "Almeno 8 caratteri",
    "pwd.rule.uppercase": "Almeno una lettera maiuscola",
    "pwd.rule.lowercase": "Almeno una lettera minuscola",
    "pwd.rule.number": "Almeno un numero",
    "pwd.rule.special": "Almeno un carattere speciale",

    // Profile / User Settings
    "profile.title": "Impostazioni Profilo",
    "profile.subtitle": "Gestisci il tuo account e la password",
    "profile.changePassword": "Cambia Password",
    "profile.changePasswordDesc": "Aggiorna la password del tuo account",
    "profile.currentPassword": "Password Attuale",
    "profile.currentPasswordPlaceholder": "Inserisci la password attuale",
    "profile.savePassword": "Aggiorna Password",
    "profile.saving": "Aggiornamento...",
    "profile.passwordChanged": "Password aggiornata con successo",
    "profile.passwordChangeFailed": "Aggiornamento password fallito",

    // Login
    "login.title": "Accedi",
    "login.subtitle": "Inserisci le tue credenziali per accedere",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Accedi",
    "login.contactAdmin": "Contatta il tuo amministratore per l'accesso",
    "login.brandSubtitle": "Strumenti interni e gestione progetti",
    "login.forgotPassword": "Hai dimenticato la password?",

    // Forgot Password
    "forgot.title": "Reimposta Password",
    "forgot.subtitle": "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
    "forgot.submit": "Invia Link di Reset",
    "forgot.hint": "Riceverai un'email con un link per creare una nuova password",
    "forgot.backToLogin": "Torna all'accesso",
    "forgot.sentTitle": "Controlla la tua email",
    "forgot.sentMessage": "Se esiste un account per {email}, abbiamo inviato un link per il reset della password.",

    // Reset Password
    "reset.title": "Imposta Nuova Password",
    "reset.subtitle": "Scegli una nuova password sicura per il tuo account.",
    "reset.submit": "Reimposta Password",
    "reset.hint": "La tua password deve soddisfare tutti i requisiti di complessit\u00e0",
    "reset.successTitle": "Password Reimpostata",
    "reset.successMessage": "La tua password \u00e8 stata reimpostata con successo. Ora puoi accedere con la nuova password.",
    "reset.goToLogin": "Accedi",
    "reset.invalidTitle": "Link di Reset Non Valido",
    "reset.invalidMessage": "Questo link di reset della password non \u00e8 valido o mancante. Richiedine uno nuovo.",
    "reset.requestNew": "Richiedi un nuovo link di reset",

    // Home
    "home.welcome": "Bentornato,",
    "home.projects": "Progetti",
    "home.settings": "Impostazioni",

    // Month names
    "month_1": "Gennaio",
    "month_2": "Febbraio",
    "month_3": "Marzo",
    "month_4": "Aprile",
    "month_5": "Maggio",
    "month_6": "Giugno",
    "month_7": "Luglio",
    "month_8": "Agosto",
    "month_9": "Settembre",
    "month_10": "Ottobre",
    "month_11": "Novembre",
    "month_12": "Dicembre",

    // Day abbreviations (0=Monday, 6=Sunday)
    "day_0": "Lun",
    "day_1": "Mar",
    "day_2": "Mer",
    "day_3": "Gio",
    "day_4": "Ven",
    "day_5": "Sab",
    "day_6": "Dom",

    // Projects page
    "projects.title": "Progetti",
    "projects.newProject": "Nuovo Progetto",
    "projects.search": "Cerca progetti...",
    "projects.allStatus": "Tutti gli stati",
    "projects.allCategories": "Tutte le categorie",
    "projects.noProjects": "Nessun progetto trovato",
    "projects.noActive": "Nessun progetto attivo",
    "projects.closedSection": "Progetti Chiusi",
    "projects.backToHome": "Torna alla Home",

    // Create project dialog
    "projects.create.title": "Crea Progetto",
    "projects.create.name": "Titolo",
    "projects.create.namePlaceholder": "Nome del progetto",
    "projects.create.description": "Descrizione",
    "projects.create.descriptionPlaceholder": "Breve descrizione del progetto",
    "projects.create.status": "Stato",
    "projects.create.category": "Categoria",
    "projects.create.categoryPlaceholder": "Seleziona una categoria",
    "projects.create.cancel": "Annulla",
    "projects.create.submit": "Crea",

    // Statuses
    "status.notStarted": "Non Iniziato",
    "status.open": "Aperto",
    "status.closed": "Chiuso",

    // Project detail
    "project.backToProjects": "Torna ai progetti",
    "project.updates": "Aggiornamenti",
    "project.files": "File",
    "project.meetings": "Riunioni",
    "project.noDescription": "Nessuna descrizione",
    "project.updatePlaceholder": "Condividi un aggiornamento su questo progetto...",
    "project.attach": "Allega",
    "project.post": "Pubblica",
    "project.noUpdates": "Nessun aggiornamento ancora. Sii il primo ad aggiungerne uno!",
    "project.dropUpload": "Trascina o clicca per caricare",
    "project.noFiles": "Nessun file caricato",
    "project.addMeeting": "Aggiungi",
    "project.allMeetings": "Tutte le Riunioni",
    "project.noMeetingsDate": "Nessuna riunione il",
    "project.noMeetings": "Nessuna riunione programmata",
    "project.past": "Passato",
    "project.deleteProject": "Elimina Progetto",
    "project.deleteProjectDesc": "Questo eliminerà permanentemente il progetto e tutti i suoi aggiornamenti e file.",
    "project.deleteUpdate": "Elimina Aggiornamento",
    "project.deleteUpdateDesc": "Sei sicuro di voler eliminare questo aggiornamento? L'azione non può essere annullata.",
    "project.meeting": "Riunione",
    "project.selectCategory": "Seleziona categoria",

    // Meeting dialog
    "meeting.schedule": "Programma Riunione",
    "meeting.title": "Titolo",
    "meeting.titlePlaceholder": "Titolo della riunione",
    "meeting.date": "Data",
    "meeting.startTime": "Ora Inizio",
    "meeting.endTime": "Ora Fine",
    "meeting.cancel": "Annulla",
    "meeting.create": "Crea",

    // File preview
    "file.view": "Visualizza",
    "file.download": "Scarica",
    "file.close": "Chiudi",

    // Settings
    "settings.title": "Impostazioni",
    "settings.subtitle": "Gestisci la configurazione del workspace",
    "settings.users": "Utenti",
    "settings.categories": "Categorie",
    "settings.addUser": "Aggiungi Utente",
    "settings.addCategory": "Aggiungi Categoria",
    "settings.backToHome": "Torna alla Home",
    "settings.projects": "Progetti",
    "settings.projectsDesc": "Categorie e configurazione dei progetti",
    "settings.decayCalculator": "Calcolatore Decadimento",
    "settings.decayDesc": "Database di elementi e isotopi",
    "settings.usersDesc": "Membri del team e controllo accessi",
    "settings.emailDesc": "SMTP e autenticazione a due fattori",

    // Users table
    "users.user": "Utente",
    "users.role": "Ruolo",
    "users.joined": "Registrato",
    "users.actions": "Azioni",
    "users.admin": "Admin",
    "users.managerRole": "Manager",
    "users.userRole": "Utente",

    // Edit user
    "users.edit.title": "Modifica Utente",
    "users.edit.displayName": "Nome Visualizzato",
    "users.edit.color": "Colore",
    "users.edit.role": "Ruolo",
    "users.edit.newPassword": "Nuova Password (opzionale)",
    "users.edit.newPasswordPlaceholder": "Lascia vuoto per mantenere la corrente",
    "users.edit.cancel": "Annulla",
    "users.edit.save": "Salva",

    // Create user
    "users.create.title": "Crea Nuovo Utente",
    "users.create.email": "Email",
    "users.create.emailPlaceholder": "utente@azienda.com",
    "users.create.password": "Password",
    "users.create.passwordPlaceholder": "Password",
    "users.create.displayName": "Nome Visualizzato",
    "users.create.displayNamePlaceholder": "Mario Rossi",
    "users.create.role": "Ruolo",
    "users.create.submit": "Crea Utente",
    "users.create.cancel": "Annulla",

    // Delete user
    "users.delete.title": "Elimina Utente",
    "users.delete.desc": "Sei sicuro di voler eliminare {name}? L'azione non può essere annullata.",
    "users.delete.cancel": "Annulla",
    "users.delete.confirm": "Elimina",

    // Categories
    "categories.edit": "Modifica Categoria",
    "categories.new": "Nuova Categoria",
    "categories.name": "Nome Categoria",
    "categories.namePlaceholder": "es. Marketing, Sviluppo",
    "categories.color": "Colore Categoria",
    "categories.save": "Salva",
    "categories.cancel": "Annulla",
    "categories.noCategories": "Nessuna categoria",
    "categories.delete.title": "Elimina Categoria",
    "categories.delete.desc": 'Sei sicuro di voler eliminare "{name}"? I progetti che usano questa categoria dovranno essere aggiornati.',

    // Common
    "common.cancel": "Annulla",
    "common.delete": "Elimina",
    "common.save": "Salva",
    "common.close": "Chiudi",
    "common.confirmDelete": "Conferma eliminazione",
    "common.create": "Crea",
    "common.by": "da",

    // Lockout
    "login.accountLocked": "Il tuo account è stato bloccato a causa di troppi tentativi di accesso falliti. Reimposta la password via email o contatta un amministratore per sbloccarlo.",
    "users.locked": "Bloccato",
    "users.unlock": "Sblocca",
    "users.unlockSuccess": "Account sbloccato con successo",
    "users.unlockError": "Impossibile sbloccare l'account",
    "users.unlockConfirmTitle": "Sblocca Account",
    "users.unlockConfirmDesc": "Questo sbloccherà l'account di {name} e consentirà di accedere nuovamente.",

    // Toasts
    "toast.statusUpdated": "Stato aggiornato",
    "toast.categoryUpdated": "Categoria aggiornata",
    "toast.updateAdded": "Aggiornamento aggiunto",
    "toast.updateDeleted": "Aggiornamento eliminato",
    "toast.fileUploaded": "File caricato",
    "toast.fileDeleted": "File eliminato",
    "toast.meetingCreated": "Riunione creata",
    "toast.meetingDeleted": "Riunione eliminata",
    "toast.projectDeleted": "Progetto eliminato",
    "toast.projectCreated": "Progetto creato",
    "toast.titleUpdated": "Titolo aggiornato",
    "toast.descriptionUpdated": "Descrizione aggiornata",
    "toast.userUpdated": "Utente aggiornato",
    "toast.userCreated": "Utente creato",
    "toast.userDeleted": "Utente eliminato",
    "toast.categoryCreated": "Categoria creata",
    "toast.categorySaved": "Categoria aggiornata",
    "toast.categoryDeleted": "Categoria eliminata",
    "toast.languageUpdated": "Lingua aggiornata",
    "toast.failedLoad": "Caricamento dati fallito",
    "toast.failedLoadProject": "Caricamento progetto fallito",
    "toast.noChanges": "Nessuna modifica da salvare",

    // 2FA
    "login.2fa.title": "Autenticazione a due fattori",
    "login.2fa.subtitle": "Abbiamo inviato un codice a 6 cifre a {email}",
    "login.2fa.verify": "Verifica",
    "login.2fa.resend": "Reinvia codice",
    "login.2fa.sending": "Invio...",
    "login.2fa.codeSent": "Un nuovo codice è stato inviato alla tua email.",
    "login.2fa.back": "Torna al login",
    "login.2fa.expires": "Il codice scade tra 10 minuti",

    // SMTP / Email Settings
    "settings.email": "Email",
    "smtp.title": "Configurazione Email",
    "smtp.description": "Configura le impostazioni SMTP per abilitare l'autenticazione a due fattori e le notifiche email.",
    "smtp.host": "Host SMTP",
    "smtp.hostPlaceholder": "smtp.gmail.com",
    "smtp.port": "Porta",
    "smtp.username": "Nome utente",
    "smtp.usernamePlaceholder": "tua-email@gmail.com",
    "smtp.password": "Password",
    "smtp.passwordPlaceholder": "Password app o password SMTP",
    "smtp.senderEmail": "Email Mittente",
    "smtp.senderPlaceholder": "noreply@tuaazienda.com",
    "smtp.save": "Salva Impostazioni",
    "smtp.saving": "Salvataggio...",
    "smtp.saved": "Impostazioni SMTP salvate",
    "smtp.saveFailed": "Salvataggio impostazioni SMTP fallito",
    "smtp.testTitle": "Invia Email di Test",
    "smtp.testEmail": "Email Destinatario",
    "smtp.testEmailPlaceholder": "test@esempio.com",
    "smtp.sendTest": "Invia Test",
    "smtp.sending": "Invio...",
    "smtp.testSuccess": "Email di test inviata con successo",
    "smtp.testFailed": "Invio email di test fallito",
    "smtp.notConfigured": "SMTP non ancora configurato. Salva prima le impostazioni.",
    "smtp.configured": "Configurato",
    "smtp.notConfiguredBadge": "Non configurato",
    "smtp.2faNote": "Quando SMTP è configurato, l'autenticazione a due fattori viene automaticamente abilitata per tutti gli utenti su nuovi dispositivi.",
    "smtp.2faToggleTitle": "Autenticazione a due fattori (2FA)",
    "smtp.2faToggleDesc": "Quando abilitata, gli utenti devono verificare la propria identità via email su nuovi dispositivi.",
    "smtp.2faStatusOn": "2FA attiva — verifica email richiesta su nuovi dispositivi",
    "smtp.2faStatusOff": "2FA disabilitata — accesso solo con password",
    "smtp.2faEnabled": "Autenticazione a due fattori abilitata",
    "smtp.2faDisabled": "Autenticazione a due fattori disabilitata",

    // Security / Key Rotation
    "settings.security": "Sicurezza",
    "settings.securityDesc": "Crittografia e protezione dati",
    "security.dbEncryption": "Crittografia Database",
    "security.dbEncryptionDesc": "Tutti i dati sensibili sono crittografati a riposo con AES-256-GCM.",
    "security.fileEncryption": "Crittografia File",
    "security.fileEncryptionDesc": "Crittografia per file e allegati caricati.",
    "security.comingSoon": "In arrivo",
    "security.keyWarning": "Se la chiave di crittografia viene persa, tutti i dati del database diventano permanentemente irrecuperabili. Conserva la chiave in un luogo sicuro.",
    "security.rotateKey": "Ruota Chiave di Crittografia",
    "security.rotateDesc": "Sostituisci la chiave di crittografia corrente. Tutti i dati saranno ri-crittografati con la nuova chiave.",
    "security.currentKey": "Chiave Corrente",
    "security.currentKeyPlaceholder": "Inserisci la chiave di crittografia corrente",
    "security.newKey": "Nuova Chiave",
    "security.newKeyPlaceholder": "Inserisci la nuova chiave (min 8 caratteri)",
    "security.rotate": "Ruota Chiave",
    "security.rotating": "Rotazione...",
    "security.rotateSuccess": "Chiave di crittografia ruotata con successo",

    // Key Rotation Banner
    "keyRotation.actionRequired": "Azione richiesta su Railway",
    "keyRotation.dbKeyPending": "La rotazione della chiave di crittografia del database è stata eseguita, ma la variabile d'ambiente ENCRYPTION_KEY su Railway non è ancora stata aggiornata.",
    "keyRotation.fileKeyPending": "La rotazione della chiave di crittografia dei file è stata eseguita, ma la variabile d'ambiente R2_ENCRYPTION_KEY su Railway non è ancora stata aggiornata.",
    "keyRotation.step1": "Aggiorna {KEY} nelle Variabili di Railway con il nuovo valore",
    "keyRotation.step2": "Ridistribuisci il servizio",
    "keyRotation.autoResolve": "Questo banner scomparirà automaticamente al completamento della ridistribuzione.",
    "keyRotation.modalTitle": "Azione richiesta su Railway",
    "keyRotation.modalBody": "La rotazione della chiave è stata completata con successo. Devi ora aggiornare la variabile d'ambiente su Railway e ridistribuire affinché la modifica persista tra i riavvii.",
    "keyRotation.modalConfirm": "Ho capito",
    "security.rotateFailed": "Rotazione chiave fallita",
    "security.active": "Attiva",

    // SharePoint
    "sharepoint.title": "SharePoint",
    "sharepoint.subtitle": "Archiviazione e condivisione file",
    "sharepoint.file": "file",
    "sharepoint.files": "file",
    "sharepoint.root": "SharePoint",
    "sharepoint.upload": "Carica",
    "sharepoint.uploading": "Caricamento...",
    "sharepoint.newFolder": "Nuova Cartella",
    "sharepoint.folderName": "Nome cartella",
    "sharepoint.folderNamePlaceholder": "Inserisci nome cartella",
    "sharepoint.create": "Crea",
    "sharepoint.emptyFolder": "Questa cartella è vuota",
    "sharepoint.emptyFolderDesc": "Carica file o crea una nuova cartella per iniziare.",
    "sharepoint.newFolderDesc": "Inserisci un nome per la nuova cartella.",
    "sharepoint.previewUnavailable": "Anteprima non disponibile",
    "sharepoint.renameDesc": "Inserisci un nuovo nome per questo elemento.",
    "sharepoint.name": "Nome",
    "sharepoint.type": "Tipo",
    "sharepoint.size": "Dimensione",
    "sharepoint.date": "Data",
    "sharepoint.actions": "Azioni",
    "sharepoint.folder": "Cartella",
    "sharepoint.properties": "Proprietà",
    "sharepoint.uploadedBy": "Caricato da",
    "sharepoint.download": "Scarica",
    "sharepoint.loadError": "Errore nel caricamento dei file",
    "sharepoint.folderCreated": "Cartella creata",
    "sharepoint.folderError": "Errore nella creazione della cartella",
    "sharepoint.fileUploaded": "File caricato",
    "sharepoint.filesUploaded": "{count} file caricati",
    "sharepoint.uploadError": "Caricamento fallito",
    "sharepoint.uploadTooLarge": "Il file supera il limite di 5 GB.",
    "sharepoint.deleted": "Elemento eliminato",
    "sharepoint.deleteError": "Errore nell'eliminazione",
    "sharepoint.conflictTitle": "File Gi\u00e0 Esistente",
    "sharepoint.conflictDescSingle": "Un file chiamato \"{name}\" esiste gi\u00e0 in questa cartella.",
    "sharepoint.conflictDescMulti": "{count} file esistono gi\u00e0 in questa cartella.",
    "sharepoint.conflictReplace": "Sostituisci",
    "sharepoint.conflictKeepBoth": "Mantieni Entrambi",
    "sharepoint.deleteConfirmTitle": "Elimina elemento",
    "sharepoint.deleteFolderDesc": "Eliminare la cartella \"{name}\" e tutto il suo contenuto? Non è possibile annullare.",
    "sharepoint.deleteFileDesc": "Eliminare il file \"{name}\"? Non è possibile annullare.",
    "sharepoint.dropHere": "Trascina i file qui per caricarli",
    "sharepoint.rename": "Rinomina",
    "sharepoint.renamed": "Elemento rinominato",
    "sharepoint.renameError": "Rinomina fallita",
    "sharepoint.ctxOpen": "Apri",
    "sharepoint.copy": "Copia",
    "sharepoint.paste": "Incolla",
    "sharepoint.copied": "\"{name}\" copiato negli appunti",
    "sharepoint.pasted": "\"{name}\" incollato",
    "sharepoint.pasteError": "Incolla fallito",
    "sharepoint.preview": "Anteprima",
    "sharepoint.previewError": "Impossibile generare l'anteprima",
    "sharepoint.preparingPreview": "Preparazione anteprima...",
    "sharepoint.previewNotAvailable": "Anteprima Non Disponibile",
    "sharepoint.previewNotAvailableDesc": "L'anteprima non è disponibile per \"{name}\". Puoi scaricare il file.",

    // Search
    "sharepoint.searchPlaceholder": "Cerca file e cartelle...",
    "sharepoint.searchNoResults": "Nessun risultato trovato",
    "sharepoint.searchError": "Ricerca fallita",

    // Multi-select & Bulk operations
    "sharepoint.itemsSelected": "{count} elementi selezionati",
    "sharepoint.totalItems": "{count} elementi",
    "sharepoint.cut": "Taglia",
    "sharepoint.pasteHere": "Incolla qui",
    "sharepoint.deleteSelected": "Elimina {count} elementi",
    "sharepoint.downloadZip": "Scarica come ZIP",
    "sharepoint.bulkDeleteTitle": "Eliminare {count} elementi?",
    "sharepoint.bulkDeleteDesc": "I seguenti elementi verranno eliminati definitivamente:",
    "sharepoint.bulkDeleted": "{count} elementi eliminati",
    "sharepoint.bulkMoved": "{count} elementi spostati",
    "sharepoint.bulkCopied": "{count} elementi copiati",
    "sharepoint.cutActive": "{count} elementi tagliati negli appunti",
    "sharepoint.copiedMulti": "{count} elementi copiati negli appunti",
    "sharepoint.moveError": "Impossibile spostare gli elementi",
    "sharepoint.copyError": "Impossibile copiare gli elementi",
    "sharepoint.listView": "Vista elenco",
    "sharepoint.gridView": "Vista griglia",

    // Office URI Scheme
    "sharepoint.openingInExcel": "Apertura in Excel...",
    "sharepoint.openingInWord": "Apertura in Word...",
    "sharepoint.openingInPowerPoint": "Apertura in PowerPoint...",
    "sharepoint.officeFallback": "Office desktop non rilevato. Apertura nell'anteprima del browser...",
    "sharepoint.lastModified": "Ultima Modifica",
    "sharepoint.fullPath": "Percorso Completo",
    "sharepoint.formatExcel": "Foglio di Calcolo Microsoft Excel",
    "sharepoint.formatWord": "Documento Microsoft Word",
    "sharepoint.formatPowerPoint": "Presentazione Microsoft PowerPoint",
    "sharepoint.formatPdf": "Documento PDF",
    "sharepoint.formatImage": "Immagine",
    "sharepoint.formatVideo": "Video",
    "sharepoint.formatAudio": "Audio",
    "sharepoint.formatArchive": "Archivio",
    "sharepoint.formatText": "Documento di Testo",
    "sharepoint.formatFile": "File",
    "sharepoint.selectAll": "Seleziona tutto",
    "sharepoint.officeSaved": "File salvato dall'applicazione desktop",

    // Pinned folders
    "sharepoint.pinToSidebar": "Aggiungi alla barra laterale",
    "sharepoint.unpinFromSidebar": "Rimuovi dalla barra laterale",
    "sharepoint.pinnedFolders": "Fissati",
    "sharepoint.filesLabel": "file",
    "sharepoint.backToHome": "Torna alla Home",

    // Archive Viewer
    "archive.sessionExpired": "Sessione archivio scaduta o non trovata",
    "archive.loadError": "Impossibile caricare i contenuti dell'archivio",
    "archive.previewError": "Impossibile visualizzare il file",
    "archive.downloadError": "Impossibile scaricare il file",
    "archive.noSession": "Nessuna sessione archivio trovata",
    "archive.tempSession": "Sessione temporanea",
    "archive.back": "Indietro",
    "archive.empty": "Questa cartella è vuota",
    "archive.colName": "Nome",
    "archive.colSize": "Dimensione",
    "archive.colType": "Tipo",
    "archive.colActions": "Azioni",
    "archive.folder": "Cartella",
    "archive.preview": "Anteprima",
    "archive.downloadFile": "Scarica",

    // Settings — SharePoint
    "settings.sharepoint": "SharePoint",
    "settings.sharepointDesc": "Configurazione storage R2",
    "r2.title": "Configurazione Cloudflare R2",
    "r2.description": "Configura lo storage S3-compatibile per la gestione file di SharePoint.",
    "r2.accessKeyId": "Access Key ID",
    "r2.secretAccessKey": "Secret Access Key",
    "r2.endpointUrl": "Endpoint URL",
    "r2.endpointPlaceholder": "https://tuo-account-id.r2.cloudflarestorage.com",
    "r2.bucketName": "Nome Bucket",
    "r2.save": "Salva Configurazione",
    "r2.saving": "Salvataggio...",
    "r2.saved": "Configurazione R2 salvata",
    "r2.saveFailed": "Salvataggio configurazione R2 fallito",
    "r2.configured": "Configurato",
    "r2.notConfigured": "Non configurato",
    "r2.testConnection": "Testa Connessione",
    "r2.testing": "Test...",
    "r2.testSuccess": "Connessione riuscita",
    "r2.testFailed": "Connessione fallita",

    // Backup R2 Configuration
    "backupR2.title": "Configurazione Backup",
    "backupR2.description": "Configura un bucket R2 dedicato per i backup crittografati.",
    "backupR2.accessKeyId": "Backup Access Key ID",
    "backupR2.secretAccessKey": "Backup Secret Access Key",
    "backupR2.endpointUrl": "Backup Endpoint URL",
    "backupR2.bucketName": "Backup Bucket Name",
    "backupR2.saved": "Configurazione backup R2 salvata",
    "backupR2.saveFailed": "Salvataggio configurazione backup R2 fallito",

    // Backup
    "backup.title": "Backup",
    "backup.subtitle": "Scegli come eseguire il backup di tutti i file SharePoint.",
    "backup.description": "Scegli come eseguire il backup di tutti i file SharePoint.",
    "backup.localTitle": "Scarica localmente",
    "backup.localBackup": "Scarica localmente",
    "backup.localDesc": "Scarica tutti i file come archivio .zip decrittografato sul tuo computer.",
    "backup.r2Title": "Backup su Cloudflare R2",
    "backup.r2Backup": "Backup su Cloudflare R2",
    "backup.r2Desc": "Invia tutti i file (crittografati) al bucket R2 di backup dedicato.",
    "backup.warning": "Conferma",
    "backup.confirmLocal": "Questo backup contiene file sensibili decrittografati. Conserva l'archivio scaricato in modo sicuro.",
    "backup.confirmR2": "Verrà caricato un .zip con timestamp di tutti i file crittografati sul bucket R2 di backup.",
    "backup.localWarning": "Questo backup contiene file sensibili decrittografati. Conserva l'archivio scaricato in modo sicuro.",
    "backup.r2Warning": "Verrà caricato un .zip con timestamp di tutti i file crittografati sul bucket R2 di backup.",
    "backup.confirm": "Avvia Backup",
    "backup.startBackup": "Avvia Backup",
    "backup.inProgress": "Backup in corso...",
    "backup.localSuccess": "Backup scaricato con successo",
    "backup.localError": "Download del backup fallito",
    "backup.r2Success": "Backup caricato su R2 con successo",
    "backup.r2Error": "Caricamento backup su R2 fallito",

    // Settings — File Encryption
    "security.fileKeyTitle": "Chiave Crittografia File",
    "security.fileKeyDesc": "Imposta la chiave di crittografia AES-256 utilizzata per tutti i file in SharePoint.",
    "security.fileKeyWarning": "Se la chiave di crittografia file viene persa, tutti i file in SharePoint diventano permanentemente irrecuperabili.",
    "security.fileKeyPlaceholder": "Inserisci la chiave di crittografia file (min 8 caratteri)",
    "security.fileKeySave": "Salva Chiave",
    "security.fileKeySaving": "Salvataggio...",
    "security.fileKeySaved": "Chiave crittografia file salvata",
    "security.fileKeySaveFailed": "Salvataggio chiave fallito",
    "security.fileKeyEnvOnly": "La chiave di crittografia file è gestita come variabile d'ambiente Railway (R2_ENCRYPTION_KEY). Impostala direttamente su Railway e riavvia il servizio per attivare la crittografia.",
    "security.fileKeyRotateDesc": "Sostituisci la chiave di crittografia file corrente. Tutti i file saranno ri-crittografati con la nuova chiave.",
    "security.rotateFileKey": "Ruota Chiave Crittografia File",
    "security.currentFileKey": "Chiave File Corrente",
    "security.newFileKey": "Nuova Chiave File",
    "security.rotateFileSuccess": "Chiave crittografia file ruotata con successo",
    "security.rotateFileFailed": "Rotazione chiave file fallita",

    // Language
    "lang.english": "English",
    "lang.italian": "Italiano",

    // Audit Log
    "settings.auditLog": "Registro Attivit\u00e0",
    "settings.auditDesc": "Cronologia eventi e attivit\u00e0 di sicurezza",
    "audit.title": "Registro Attivit\u00e0",
    "audit.backToHome": "Torna alla Home",
    "audit.subtitle": "Tutti gli eventi di sistema e le azioni degli utenti",
    "audit.fetchError": "Impossibile caricare il registro attivit\u00e0",
    "audit.search": "Cerca",
    "audit.searchPlaceholder": "Cerca azioni, utenti...",
    "audit.user": "Utente",
    "audit.allUsers": "Tutti gli utenti",
    "audit.actionType": "Tipo",
    "audit.allTypes": "Tutti i tipi",
    "audit.from": "Da",
    "audit.to": "A",
    "audit.clearFilters": "Cancella",
    "audit.noEntries": "Nessuna voce nel registro attivit\u00e0",
    "audit.showing": "Mostrando",
    "audit.of": "di",
    "audit.exportPDF": "Esporta PDF",
    "audit.exportSuccess": "Registro attivit\u00e0 esportato con successo",
    "audit.exportError": "Impossibile esportare il registro attivit\u00e0",
    "audit.appliedFilters": "Filtri applicati",
    "audit.totalEntries": "Voci totali",
    "audit.exported": "Esportato il",
    "audit.col.datetime": "Data / Ora",
    "audit.col.user": "Utente",
    "audit.col.action": "Azione",
    "audit.col.type": "Tipo",
    "audit.col.ip": "Indirizzo IP",
    "audit.type.auth": "Autenticazione",
    "audit.type.user": "Utente",
    "audit.type.password": "Password",
    "audit.type.settings": "Impostazioni",
    "audit.type.security": "Sicurezza",
    "audit.type.sharepoint": "SharePoint",
    "audit.type.backup": "Backup",
    "audit.type.other": "Altro",

    // Home
    "home.decayCalculator": "Calcolatore Decadimento",
    "home.planning": "Pianificazione",
    "home.sharepoint": "SharePoint",
    "home.accounting": "Contabilit\u00e0",

    // Accounting
    "accounting.title": "Contabilit\u00e0",
    "accounting.subtitle": "Gestione finanziaria",
    "accounting.backToHome": "Torna alla Home",
    "accounting.expenseReports": "Note Spese",
    "accounting.employee": "Dipendente",
    "accounting.amount": "Importo",
    "accounting.total": "Totale",
    "accounting.noData": "Nessun dato disponibile per questo mese",
    "accounting.fetchError": "Impossibile caricare le note spese",

    // Planning
    "planning.title": "Pianificazione",
    "planning.backToHome": "Torna alla Home",
    "planning.subtitle": "Fogli di calcolo per la pianificazione annuale",
    "planning.currentYear": "Anno Corrente",
    "planning.previousYears": "Anni Precedenti",
    "planning.openInExcel": "Apri in Excel",
    "planning.noFiles": "Nessun file di pianificazione trovato",
    "planning.noFilesDesc": "Carica file Planning_YYYY.xlsx nella cartella Planning su SharePoint.",
    "planning.openingExcel": "Apertura in Excel...",
    "planning.fallbackPreview": "Excel non rilevato, apertura anteprima web...",
    "planning.goToFolder": "Apri Cartella Planning",
    "planning.lastModified": "Ultima modifica",

    // Planning Calendar
    "planningCal.date": "Data",
    "planningCal.futureTasks": "Attività Future",
    "planningCal.loadError": "Impossibile caricare i dati del calendario",

    // Decay Calculator
    "decay.title": "Calcolatore Decadimento",
    "decay.backToHome": "Torna alla Home",
    "decay.element": "Elemento",
    "decay.isotope": "Isotopo",
    "decay.selectElement": "Seleziona un elemento",
    "decay.selectIsotope": "Seleziona un isotopo",
    "decay.selectElementFirst": "Seleziona prima un elemento",
    "decay.initialActivity": "Attività Iniziale",
    "decay.inputUnit": "Unità Input",
    "decay.outputUnit": "Unità Output",
    "decay.originDate": "Data Origine",
    "decay.originTime": "Ora Origine",
    "decay.targetDate": "Data Target",
    "decay.targetTime": "Ora Target",
    "decay.calculate": "Calcola",
    "decay.result": "Risultato",
    "decay.halfLife": "Tempo di dimezzamento",
    "decay.originDateTime": "Data/Ora Origine",
    "decay.targetDateTime": "Data/Ora Target",
    "decay.elapsedTime": "Tempo Trascorso",
    "decay.decayFactor": "Fattore di Decadimento",
    "decay.finalActivity": "Attività Finale",
    "decay.noElements": "Nessun elemento disponibile. Un amministratore deve prima aggiungere elementi e isotopi.",
    "decay.errorTargetBeforeOrigin": "Il target deve essere dopo l'origine",
    "decay.print": "Stampa / Salva come PDF",
    "decay.tabDateTime": "Data e Ora",
    "decay.tabQuick": "Rapido",
    "decay.quickTimeLabel": "Tempo",
    "decay.quickBefore": "Prima",
    "decay.quickAfter": "Dopo",
    "decay.quickTimeDelta": "Delta Temporale",
    "decay.timeUnit_seconds": "Secondi",
    "decay.timeUnit_minutes": "Minuti",
    "decay.timeUnit_hours": "Ore",
    "decay.timeUnit_days": "Giorni",
    "decay.timeUnit_years": "Anni",

    // Settings - Isotopes
    "settings.isotopes": "Isotopi",
    "isotopes.addElement": "Aggiungi Elemento",
    "isotopes.addIsotope": "Aggiungi Isotopo",
    "isotopes.elementName": "Nome Elemento",
    "isotopes.elementPlaceholder": "es. Gallio, Fluoro",
    "isotopes.isotopeName": "Nome Isotopo",
    "isotopes.isotopePlaceholder": "es. Ga-68, F-18",
    "isotopes.halfLifeValue": "Valore Tempo di Dimezzamento",
    "isotopes.halfLifeUnit": "Unità Tempo di Dimezzamento",
    "isotopes.noElements": "Nessun elemento ancora. Aggiungi un elemento per iniziare.",
    "isotopes.noIsotopes": "Nessun isotopo. Clicca + per aggiungerne uno.",
    "isotopes.deleteElement": "Elimina Elemento",
    "isotopes.deleteElementDesc": 'Eliminare "{name}" e tutti i suoi isotopi?',
    "isotopes.editElement": "Modifica Elemento",
    "isotopes.editIsotope": "Modifica Isotopo",
    "isotopes.newIsotope": "Nuovo Isotopo",
    "isotopes.newElement": "Nuovo Elemento",
    "isotopes.seconds": "secondi",
    "isotopes.minutes": "minuti",
    "isotopes.hours": "ore",
    "isotopes.days": "giorni",
    "isotopes.years": "anni",

    // Trasferte
    "nav.trasferte": "Trasferte",
    "home.trasferte": "Trasferte",
    "trasferte.title": "Trasferte",
    "trasferte.subtitle": "Archivio conoscenza viaggi di lavoro",
    "trasferte.searchPlaceholder": "Cerca un paese…",
    "trasferte.selectInstruction": "Seleziona un paese sulla mappa",
    "trasferte.cityPlaceholder": "Citt\u00e0 non specificata",
    "trasferte.selectPrompt": "Clicca un paese sulla mappa o cerca qui sopra per vedere i dettagli.",
    "trasferte.tabInfo": "Info Paese",
    "trasferte.tabTrips": "Trasferte Passate",
    "trasferte.pastTripsIn": "Trasferte passate in",
    "trasferte.noTrips": "Nessuna trasferta registrata per questo paese.",
    "trasferte.loadError": "Caricamento trasferte fallito",
    "trasferte.loading": "Caricamento…",
    "trasferte.localCurrency": "Valuta Locale",
    "trasferte.currencyUnknown": "Informazioni valuta non disponibili",
    "trasferte.exchangeRate": "Tasso di Cambio Live",
    "trasferte.lastUpdated": "Ultimo aggiornamento",
    "trasferte.rateError": "Tasso al momento non disponibile",
    "trasferte.viaggiareSicuri": "Consulta Viaggiare Sicuri (MAE)",
    "trasferte.addTrip": "Aggiungi Trasferta",
    "trasferte.addModalTitle": "Aggiungi Trasferta",
    "trasferte.city": "Citt\u00e0",
    "trasferte.client": "Cliente",
    "trasferte.clientName": "Nome cliente",
    "trasferte.clientContact": "Sito / indirizzo",
    "trasferte.clientContactPlaceholder": "www.esempio.com",
    "trasferte.airport": "Aeroporto utilizzato",
    "trasferte.airportPlaceholder": "es. MUC — Aeroporto di Monaco",
    "trasferte.hotels": "Hotel",
    "trasferte.hotelPlaceholder": "Nome hotel",
    "trasferte.addHotel": "Aggiungi hotel",
    "trasferte.transport.label": "Spostamenti",
    "trasferte.transport.rental": "Auto a noleggio",
    "trasferte.transport.uber": "Uber / Taxi",
    "trasferte.transport.client": "A carico del cliente",
    "trasferte.transport.public": "Mezzi pubblici",
    "trasferte.transport.other": "Altro",
    "trasferte.transportNotePlaceholder": "Nota opzionale (es. Hertz ritirata in aeroporto)",
    "trasferte.restaurants": "Ristoranti consigliati",
    "trasferte.restaurantName": "Nome ristorante",
    "trasferte.restaurantNote": "Breve nota (opzionale)",
    "trasferte.addRestaurant": "Aggiungi ristorante",
    "trasferte.tips": "Consigli vari",
    "trasferte.tipsPlaceholder": "Qualcosa da ricordare per la prossima volta…",
    "trasferte.addedBy": "Inserito da",
    "trasferte.save": "Salva Trasferta",
    "trasferte.created": "Trasferta salvata",
    "trasferte.saveError": "Salvataggio trasferta fallito",
    "trasferte.formRequiredError": "Citt\u00e0 e Nome cliente sono obbligatori",
    "trasferte.legendWithTrip": "Con trasferte",
    "trasferte.legendNoTrip": "Senza trasferte",
    "trasferte.legendSelected": "Selezionato",
    "trasferte.delete": "Elimina",
    "trasferte.deleting": "Eliminazione…",
    "trasferte.deleted": "Trasferta eliminata",
    "trasferte.deleteError": "Eliminazione trasferta fallita",
    "trasferte.deleteTrip": "Elimina trasferta",
    "trasferte.deleteTripAria": "Elimina questa trasferta",
    "trasferte.deleteTripTitle": "Eliminare questa trasferta?",
    "trasferte.deleteTripConfirm": "Sei sicuro di voler eliminare questa trasferta? L'azione non pu\u00f2 essere annullata.",

    // Nomi paesi (mostrati in tooltip, ricerca, scheda paese)
    "trasferte.country.AE": "Emirati Arabi Uniti",
    "trasferte.country.AR": "Argentina",
    "trasferte.country.AT": "Austria",
    "trasferte.country.AU": "Australia",
    "trasferte.country.BE": "Belgio",
    "trasferte.country.BG": "Bulgaria",
    "trasferte.country.BR": "Brasile",
    "trasferte.country.CA": "Canada",
    "trasferte.country.CH": "Svizzera",
    "trasferte.country.CL": "Cile",
    "trasferte.country.CN": "Cina",
    "trasferte.country.CO": "Colombia",
    "trasferte.country.CY": "Cipro",
    "trasferte.country.CZ": "Repubblica Ceca",
    "trasferte.country.DE": "Germania",
    "trasferte.country.DK": "Danimarca",
    "trasferte.country.EE": "Estonia",
    "trasferte.country.EG": "Egitto",
    "trasferte.country.ES": "Spagna",
    "trasferte.country.FI": "Finlandia",
    "trasferte.country.FR": "Francia",
    "trasferte.country.GB": "Regno Unito",
    "trasferte.country.GR": "Grecia",
    "trasferte.country.HK": "Hong Kong",
    "trasferte.country.HR": "Croazia",
    "trasferte.country.HU": "Ungheria",
    "trasferte.country.ID": "Indonesia",
    "trasferte.country.IE": "Irlanda",
    "trasferte.country.IL": "Israele",
    "trasferte.country.IN": "India",
    "trasferte.country.IS": "Islanda",
    "trasferte.country.IT": "Italia",
    "trasferte.country.JP": "Giappone",
    "trasferte.country.KR": "Corea del Sud",
    "trasferte.country.LT": "Lituania",
    "trasferte.country.LU": "Lussemburgo",
    "trasferte.country.LV": "Lettonia",
    "trasferte.country.MA": "Marocco",
    "trasferte.country.MT": "Malta",
    "trasferte.country.MX": "Messico",
    "trasferte.country.MY": "Malesia",
    "trasferte.country.NG": "Nigeria",
    "trasferte.country.NL": "Paesi Bassi",
    "trasferte.country.NO": "Norvegia",
    "trasferte.country.NZ": "Nuova Zelanda",
    "trasferte.country.PE": "Per\u00f9",
    "trasferte.country.PH": "Filippine",
    "trasferte.country.PL": "Polonia",
    "trasferte.country.PT": "Portogallo",
    "trasferte.country.QA": "Qatar",
    "trasferte.country.RO": "Romania",
    "trasferte.country.RS": "Serbia",
    "trasferte.country.RU": "Russia",
    "trasferte.country.SA": "Arabia Saudita",
    "trasferte.country.SE": "Svezia",
    "trasferte.country.SG": "Singapore",
    "trasferte.country.SI": "Slovenia",
    "trasferte.country.SK": "Slovacchia",
    "trasferte.country.TH": "Thailandia",
    "trasferte.country.TN": "Tunisia",
    "trasferte.country.TR": "Turchia",
    "trasferte.country.TW": "Taiwan",
    "trasferte.country.UA": "Ucraina",
    "trasferte.country.US": "Stati Uniti",
    "trasferte.country.VN": "Vietnam",
    "trasferte.country.ZA": "Sudafrica",

    // Nomi valute
    "trasferte.currency.AED": "Dirham degli Emirati Arabi Uniti",
    "trasferte.currency.ARS": "Peso argentino",
    "trasferte.currency.AUD": "Dollaro australiano",
    "trasferte.currency.BGN": "Lev bulgaro",
    "trasferte.currency.BRL": "Real brasiliano",
    "trasferte.currency.CAD": "Dollaro canadese",
    "trasferte.currency.CHF": "Franco svizzero",
    "trasferte.currency.CLP": "Peso cileno",
    "trasferte.currency.CNY": "Yuan cinese",
    "trasferte.currency.COP": "Peso colombiano",
    "trasferte.currency.CZK": "Corona ceca",
    "trasferte.currency.DKK": "Corona danese",
    "trasferte.currency.EGP": "Sterlina egiziana",
    "trasferte.currency.EUR": "Euro",
    "trasferte.currency.GBP": "Sterlina inglese",
    "trasferte.currency.HKD": "Dollaro di Hong Kong",
    "trasferte.currency.HUF": "Fiorino ungherese",
    "trasferte.currency.IDR": "Rupia indonesiana",
    "trasferte.currency.ILS": "Nuovo shekel israeliano",
    "trasferte.currency.INR": "Rupia indiana",
    "trasferte.currency.ISK": "Corona islandese",
    "trasferte.currency.JPY": "Yen giapponese",
    "trasferte.currency.KRW": "Won sudcoreano",
    "trasferte.currency.MAD": "Dirham marocchino",
    "trasferte.currency.MXN": "Peso messicano",
    "trasferte.currency.MYR": "Ringgit malese",
    "trasferte.currency.NGN": "Naira nigeriana",
    "trasferte.currency.NOK": "Corona norvegese",
    "trasferte.currency.NZD": "Dollaro neozelandese",
    "trasferte.currency.PEN": "Sol peruviano",
    "trasferte.currency.PHP": "Peso filippino",
    "trasferte.currency.PLN": "Z\u0142oty polacco",
    "trasferte.currency.QAR": "Riyal qatariota",
    "trasferte.currency.RON": "Leu rumeno",
    "trasferte.currency.RSD": "Dinaro serbo",
    "trasferte.currency.RUB": "Rublo russo",
    "trasferte.currency.SAR": "Riyal saudita",
    "trasferte.currency.SEK": "Corona svedese",
    "trasferte.currency.SGD": "Dollaro di Singapore",
    "trasferte.currency.THB": "Baht thailandese",
    "trasferte.currency.TND": "Dinaro tunisino",
    "trasferte.currency.TRY": "Lira turca",
    "trasferte.currency.TWD": "Nuovo dollaro taiwanese",
    "trasferte.currency.UAH": "Grivnia ucraina",
    "trasferte.currency.USD": "Dollaro statunitense",
    "trasferte.currency.VND": "Dong vietnamita",
    "trasferte.currency.ZAR": "Rand sudafricano",
  },
};

export default translations;
